import { ApplicationConfig, LOCALE_ID, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './routes';
import { environment } from 'src/environments/environment';
import { provideClientHydration, withEventReplay, withI18nSupport } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { scrollConfig } from './scroll-config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { RokezzzPaginatorIntl } from 'src/app/rokezzz/table/providers/paginator-intl';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withInMemoryScrolling(scrollConfig),
        ),
        importProvidersFrom([
            BrowserAnimationsModule,
            MatNativeDateModule
        ]),
        {
            provide: LOCALE_ID,
            useValue: environment.locale.id
        },
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: { autoFocus: 'dialog', restoreFocus: true }
        },
        {
            provide: MatPaginatorIntl,
            useValue: RokezzzPaginatorIntl.getPaginatorIntl()
        },
        provideClientHydration(
            withI18nSupport(),
            withEventReplay()
        ),
        provideHttpClient(withFetch())
    ]
};
